/**
 * currency utils
 *
 * @author Shigq
 * @date 2021/11/9 14:11
 */

/* todo methods */
/**
 * format money
 *
 * @param number
 * @param places
 * @param symbol
 * @param thousand
 * @param decimal
 * @returns {string}
 */
function formatMoney(number, places, symbol, thousand, decimal) {
	if (number === null || number === '' || number === undefined) {
		return ''
	}
	number = number.toString().replace(/[^0-9-.]/g, '')
	let strArr = number.split('.')

	number = strArr[0] + (strArr[1] ? '.' + strArr[1] : '')
	places = !isNaN(places = Math.abs(places)) ? places : 2
	symbol = symbol !== undefined ? symbol : '$'
	thousand = thousand || ',';
	decimal = decimal || '.';
	const negative = number < 0 ? '-' : ''
	const i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + ''
	let j = (j = i.length) > 3 ? j % 3 : 0
	return symbol
		+ negative
		+ (j ? i.substr(0, j) + thousand : '')
		+ i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand)
		+ (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
}

/**
 * reformat money
 *
 * @param value
 * @returns {string}
 */
function reformatMoney(value) {
	return value.toString().replace(/,/g, '')
}


module.exports = {
	formatMoney,
	reformatMoney
}
